<script setup>
import { onMounted, useTemplateRef } from "vue";
const props = defineProps(["section"]);
import store from "../store.js";
import { initExpandset } from "../../lib/expandset.js";

const expandset = useTemplateRef("expandset");

const subcats = props.section.subsections.map((sub) => sub.label).join(" - ");

onMounted(async () => {
    initExpandset(expandset.value);
});
</script>

<template>
    <details
        class="expandset is-open"
        open="true"
        data-expandset="true"
        data-expandset-animated="true"
        ref="expandset"
    >
        <summary
            class="expandset-summary size-sm product-compare-expandset-header"
        >
            <i class="icon-chevron-down size-xs-snug mr-8 mt-2"></i>
            <span class="text-md is-medium"
                >{{ section.label }}
                <span
                    v-if="subcats"
                    class="text-sm is-regular is-gray-700 d-none d-bp:md-inline"
                    >/ {{ subcats }}</span
                ></span
            >
        </summary>

        <div class="expandset-body-holder">
            <div class="expandset-body">
                <div class="product-compare-expandset-body">
                    <div
                        class="product-compare-grid mb-16"
                        v-for="subsection in section.subsections"
                        :key="subsection.id"
                    >
                        <div
                            v-for="(printer, index) in store.selectedPrinters"
                            :key="index"
                            class="product-compare-section"
                            :class="{ loaded: printer }"
                        >
                            <div
                                class="product-compare-heading text-md is-medium"
                            >
                                {{ subsection.label }}
                            </div>

                            <div
                                v-if="
                                    printer &&
                                    printer.stats &&
                                    printer.stats[subsection.id]?.length
                                "
                            >
                                <p
                                    v-for="stat in printer.stats[subsection.id]"
                                    class="mt-8"
                                >
                                    {{ stat }}
                                </p>
                            </div>

                            <p v-else class="mt-12 is-regular">&mdash;</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </details>
</template>
